import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useIsInactive = (): IGlobalStore['inactive'] => {
  return useSelector((store: IReducerStore) => store.global.inactive);
};
